import { styled as y, Box as F } from "@mui/material";
import oe from "../../../assets/icons/icon-tick.svg.js";
import ae from "../generic/Pagination.js";
import re from "../generic/SearchEmptyState.js";
import { DEFAULT_LIST_SIZE as ne } from "../../../constants/layout.js";
import { useDataGridContext as se } from "../../../contexts/share/DataGridContext.js";
import le from "../../../hooks/generic/useCSR.js";
import { noForwardProps as ie } from "../../../util/styled/index.js";
import ce from "../../../../ui-lib/components/ApeironLoadingNow.js";
import { AgGridReact as de } from "ag-grid-react";
import * as x from "ramda";
import { useState as c, useCallback as n, useEffect as A, useImperativeHandle as ue, useMemo as ge } from "react";
import { useTranslation as fe } from "react-i18next";
import { jsx as l, jsxs as he, Fragment as pe } from "react/jsx-runtime";
const me = y(F, ie)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  ${(h) => h.__autoHeight ? "height: auto;" : "height: 500px;"}

  .Custom-Grid {
    width: 100%;
    flex: 1;
    overflow: hidden;
    border-radius: 10px;

    .custom-ag-cell-left {
      justify-content: flex-start;
    }
    .custom-ag-cell-center {
      justify-content: center;
    }
    .custom-ag-cell-right {
      justify-content: flex-end;
    }
    .custom-ag-header-left {
      .ag-header-cell-label {
        justify-content: flex-start;
      }
    }
    .custom-ag-header-left {
      .ag-header-cell-label {
        justify-content: flex-start;
      }
    }
    .custom-ag-header-center {
      .ag-header-cell-label {
        justify-content: center;
      }
    }
    .custom-ag-header-right {
      .ag-header-cell-label {
        justify-content: flex-end;
      }
    }
    .ag-row-hover {
      background-color: #222225;
    }
    .ag-header {
      font-size: 16px;
    }
    .ag-header-row {
      background-color: #27272a;
    }
    .ag-body-viewport {
      background-color: #0e0e12;
    }
    .ag-cell {
      display: flex;
      align-items: center;
    }
    .ag-checkbox-input-wrapper.ag-checked {
      --background-color: #005bd7;
      --border-color: #005bd7;
    }
    .ag-checkbox-input-wrapper {
      --background-color: #363636;
      --border-color: #7a7979;
      aspect-ratio: 1;
      width: 18px;
    }
    .ag-checkbox-input-wrapper::after {
      content: '';
      aspect-ratio: 1;
      background: var(--background-color);
      border-radius: 4px;
      border: 1px solid var(--border-color);
      display: flex;
      justify-content: center;
      pointer-events: none;
      width: 18px;
    }
    .ag-checkbox-input-wrapper.ag-checked::after {
      content: url(${`"${oe}"`});
    }
  }
`, be = y(ae)`
  .Custom-Page-Button {
    background-color: #2a2a2b;
  }
`, xe = y(F)`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`, ye = () => /* @__PURE__ */ l(xe, {
  children: /* @__PURE__ */ l(ce, {})
}), He = (h) => {
  const {
    autoFetch: w = !0,
    children: U,
    className: _,
    defaultColDef: S,
    defaultPage: E,
    domLayout: k,
    emptyConfig: a,
    gridRef: B,
    pageSize: p = ne,
    selectedIds: d,
    selectionColumnDef: P,
    fetch: u,
    onSelectionChangedByPage: m,
    ...I
  } = h, {
    t: C
  } = fe(), {
    showGrid: T,
    setShowGrid: R
  } = se(), [g, V] = c({}), [e, M] = c(null), [o, v] = c(E || 1), [b, z] = c([]), [D, $] = c(0), W = le(), Z = {
    lockVisible: !0,
    sortable: !1,
    suppressMovable: !0,
    resizable: !1
  }, q = {
    maxWidth: 0
  }, J = n(async () => {
    const {
      total: t = 0
    } = await u(o, 1);
    R(t > 0);
  }, [u, o, R]), s = n(async (t, r) => {
    t.setGridOption("loading", !0);
    try {
      const {
        data: f,
        total: i = 0
      } = await u(r, p);
      z(f), v(r), $(Math.max(Math.ceil(i / p), 1)), M(t);
    } finally {
      t.setGridOption("loading", !1);
    }
  }, [u, p]), K = n((t) => {
    const {
      api: r
    } = t;
    r && w && s(r, o);
  }, [w, s, o]), Q = n(async () => {
    e && s(e, o - 1);
  }, [o, e, s]), X = n(async () => {
    e && s(e, o + 1);
  }, [o, e, s]), Y = n(async (t) => {
    e && s(e, t);
  }, [e, s]), O = n((t, r) => {
    e && e.setColumnsVisible([t], r);
  }, [e]), G = n((t = 1) => {
    e && s(e, t);
  }, [e, s]), N = n(() => {
    e && e.deselectAll();
  }, [e]), ee = n(() => /* @__PURE__ */ l(re, {
    buyURL: a == null ? void 0 : a.buyURL,
    rentURL: a == null ? void 0 : a.rentURL,
    description: C("common.no_data")
  }), [a == null ? void 0 : a.buyURL, a == null ? void 0 : a.rentURL, C]);
  A(() => {
    J();
  }, []), ue(B, () => ({
    setColumnVisible: O,
    refreshData: G,
    deselectAll: N,
    setCurrentPage: v
  }), [O, G, N]), A(() => {
    d && e && d.length > 0 && e.forEachNode((t) => {
      d.includes(String(t.data.id)) && t.setSelected(!0);
    });
  }, [e, d, o]);
  const te = n((t) => {
    const r = t.api.getSelectedRows(), f = Object.keys(g);
    let i = [];
    f.length === 0 ? i = r : i = f.reduce((j, H) => Number(H) === o ? [...j, ...r] : [...j, ...g[H]], []), m && m(i), V({
      ...g,
      [o]: r
    });
  }, [o, m, g]), L = ge(() => k === "autoHeight" && x.isNotEmpty(b), [k, b]);
  return W && T ? /* @__PURE__ */ he(me, {
    __autoHeight: L,
    className: _,
    children: [/* @__PURE__ */ l(de, {
      className: "Custom-Grid",
      defaultColDef: {
        ...Z,
        ...x.isNotNil(S) ? S : {}
      },
      domLayout: L ? "autoHeight" : "normal",
      headerHeight: 56,
      rowData: b,
      rowHeight: 80,
      suppressCellFocus: !0,
      suppressHeaderFocus: !0,
      selectionColumnDef: {
        ...q,
        ...x.isNotNil(P) ? P : {}
      },
      onGridReady: K,
      onSelectionChanged: te,
      loadingOverlayComponent: ye,
      noRowsOverlayComponent: ee,
      ...I
    }), U, /* @__PURE__ */ l(be, {
      className: "Custom-Pagination",
      nextDisabled: o === D,
      prevDisabled: o === 1,
      totalPage: D,
      value: o,
      onNext: X,
      onPrev: Q,
      onSubmit: Y
    })]
  }) : /* @__PURE__ */ l(pe, {});
};
export {
  He as ApeironPagingDataGrid,
  He as default
};
//# sourceMappingURL=ApeironPagingDataGrid.js.map
